import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { wa, DEFAULT_MSG_PT, DEFAULT_MSG_EN, PHONE_DISPLAY } from "../lib/site";

export default function FloatingWhatsApp() {
    const { lang, t } = useLang();
    const msg = lang === "pt" ? DEFAULT_MSG_PT : DEFAULT_MSG_EN;

    return (
        <a
            data-testid="floating-whatsapp-btn"
            href={wa(msg)}
            target="_blank"
            rel="noopener noreferrer"
            className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 flex items-center gap-3"
            aria-label={`WhatsApp ${PHONE_DISPLAY}`}
        >
            <span className="hidden md:block bg-white text-obsidian text-xs font-bold px-4 py-2.5 rounded-full shadow-xl opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all pointer-events-none whitespace-nowrap">
                {t.floating} · {PHONE_DISPLAY}
            </span>
            <span className="wa-pulse w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                <MessageCircle className="w-7 h-7 text-white fill-white" />
            </span>
        </a>
    );
}
